import { Link, useRouter } from "@tanstack/react-router";

/**
 * Mobile-only bottom tab bar (UX-001). Hidden ≥ sm.
 * Each tab is ≥ 44×44 px (UX-002). Uses `safe-area-inset-bottom` so iOS
 * Safari's home-indicator overlay doesn't eat the tap targets.
 */
export function BottomTabBar() {
  const router = useRouter();
  const session = router.options.context.session;

  const tabCls =
    "flex flex-col items-center justify-center min-h-[56px] py-2 text-[color:var(--color-fg-muted)] hover:text-[color:var(--color-fg)] focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-[color:var(--color-accent)]";
  const activeProps = { className: "text-[color:var(--color-fg)]" };

  return (
    <nav
      aria-label="Primary"
      className="sm:hidden fixed bottom-0 inset-x-0 z-20 border-t border-[color:var(--color-line)] bg-[color:var(--color-bg)]/95 backdrop-blur"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-4 text-[11px]">
        <li>
          <Link to="/" className={tabCls} activeProps={activeProps} aria-label="Hot">
            <span aria-hidden="true" className="text-base leading-none">🔥</span>
            <span className="mt-1">Hot</span>
          </Link>
        </li>
        <li>
          <Link to="/new" className={tabCls} activeProps={activeProps} aria-label="New">
            <span aria-hidden="true" className="text-base leading-none">🆕</span>
            <span className="mt-1">New</span>
          </Link>
        </li>
        <li>
          <Link to="/submit" className={tabCls} activeProps={activeProps} aria-label="Submit">
            <span aria-hidden="true" className="text-base leading-none">➕</span>
            <span className="mt-1">Submit</span>
          </Link>
        </li>
        <li>
          {session ? (
            <Link
              to="/alerts"
              className={tabCls}
              activeProps={activeProps}
              aria-label="Price alerts"
            >
              <span aria-hidden="true" className="text-base leading-none">🔔</span>
              <span className="mt-1">Alerts</span>
            </Link>
          ) : (
            <Link to="/login" className={tabCls} activeProps={activeProps} aria-label="Sign in">
              <span aria-hidden="true" className="text-base leading-none">👤</span>
              <span className="mt-1">Sign in</span>
            </Link>
          )}
        </li>
      </ul>
    </nav>
  );
}
